import { frontEndValidation, backEndValidation } from "./validation";
import { getFormData, sendEamil } from "./api";
import { setErrors, resetErrors } from './errors';

const rcCustomFormSubmission = (event) => {
    event.preventDefault();

    resetErrors(event.target.id);

    let dialogueBox = document.getElementById('site-alerts');
    let templateLoading = document.getElementById('alert-wip');
    let templateError = document.getElementById('alert-red');
    let templateSuccess = document.getElementById('alert-green');

    if (dialogueBox && templateLoading) {
        let templateLoadingClone = templateLoading.content.cloneNode(true);
        let loadingAnimation = templateLoadingClone.querySelector('div');
        dialogueBox.querySelector('div').innerHTML = '';
        dialogueBox.querySelector('div').appendChild(loadingAnimation);
        dialogueBox.querySelector('div').append('processing...');
        dialogueBox.show();
    }
    setTimeout(() => {
        let frontEndValidationStatus = frontEndValidation(event.target.id);

        if (frontEndValidationStatus.isSuccess) {

            (async function () {

                await backEndValidation(event.target.id).then((backEndValidationStatus) => {
                    if (backEndValidationStatus.isSuccess) {
                        let templateSuccessClone = templateSuccess.content.cloneNode(true);
                        let successAnimation = templateSuccessClone.querySelector('svg');
                        dialogueBox.querySelector('div').innerHTML = '';
                        dialogueBox.querySelector('div').appendChild(successAnimation);
                        dialogueBox.querySelector('div').append('form submitted successfully');
                        resetErrors(event.target.id);
                        setTimeout(() => {
                            dialogueBox.close();
                            document.getElementById(event.target.id).reset();
                        }, 3000);
                        const postEmail = async () => {
                            let response = await sendEamil(event.target.id, backEndValidationStatus.submissionId)};
                        postEmail();

                    } else {
                        let templateErrorClone = templateError.content.cloneNode(true);
                        let errorAnimation = templateErrorClone.querySelector('svg');
                        dialogueBox.querySelector('div').innerHTML = '';
                        dialogueBox.querySelector('div').appendChild(errorAnimation);
                        dialogueBox.querySelector('div').append('form submission failed with an error');
                        resetErrors(event.target.id);
                        setErrors(backEndValidationStatus.errors, event.target.id);
                        setTimeout(() => {
                            dialogueBox.close();
                        }, 3000);
                    }
                });

            })();

        } else {
            let templateErrorClone = templateError.content.cloneNode(true);
            let errorAnimation = templateErrorClone.querySelector('svg');
            dialogueBox.querySelector('div').innerHTML = '';
            dialogueBox.querySelector('div').appendChild(errorAnimation);
            dialogueBox.querySelector('div').append('form submission failed with an error');
            setTimeout(() => {
                dialogueBox.close();
            }, 2000);
        }

    }, 100);

}


window.addEventListener("load", (event) => {
    if (window.rcFormIds) {
        let RCcustomForms = window.rcFormIds;
        window.rcCurrentForm = [];
        RCcustomForms.forEach((rcForm, key) => {
            let form = [];
            form[key] = document.getElementById(rcForm);
            if (form[key]) {
                const fetchForm = async () => {
                    const formData = await getFormData(rcForm);
                    if (formData) {
                        window.rcCurrentForm.push(formData);
                    }
                }
                fetchForm();
                form[key].addEventListener('submit', rcCustomFormSubmission);
            }
        })
    }
});